import * as React from "react";

import { Placeholder } from "kanopi-components/Placeholder";
import { Referral } from "kw/components/QuestionFlow/Referral";
import { StatelessPayment } from "./StatelessPayment";
import { useRiskProfile } from "../hooks/useRiskProfile";
import { QuoteState } from "kw/api/zeus";

interface IPaymentProps {
  riskProfileId: number;
}

export function Payment(props: IPaymentProps) {
  const { riskProfileId } = props;
  const { riskProfile, quote, isLoading } = useRiskProfile({ riskProfileId });

  const isNotQuoted =
    isLoading === false &&
    ![QuoteState.QUOTED, QuoteState.ACCEPTED].includes(riskProfile?.state);

  return (
    <Placeholder loading={isLoading}>
      {isNotQuoted ? (
        <Referral riskProfile={riskProfile} />
      ) : (
        <StatelessPayment riskProfile={riskProfile} loading={isLoading} quote={quote} />
      )}
    </Placeholder>
  );
}
